import BugsnagPluginVue from '@bugsnag/plugin-vue';
import { init } from 'src/services/bugsnag';

/**
 * Initializes Bugsnag, installs the Vue plugin, and adds the client to the
 * Vue prototype.
 *
 * @param {Object} params
 * @param {Vue} params.Vue
 */
export default ({ Vue }) => {
  init('ui', [new BugsnagPluginVue(Vue)]);
};
